export const DEVICE_TYPE = 'web';
export const DEFAULT_MAX_ITEMS = 3;
export const INHOUSE_API_BASE_URL = 'https://api.rmn-stg.appier.info';
